module.exports = "/images/admin_info.svg?3fca08e2fccbd7389b2f6e9be64e95d5";